import { Stack } from '@mui/material'
import DashboardComponent from '../components/Dashboard/DashboardComponent'
import Header from '../components/Header/Header'

export default function Dashboard() {
  return (
    <>
      <Header />
      <Stack direction='column' padding={'100px'} alignItems='flex-start' justifyContent='flex-start'>
        <DashboardComponent />
      </Stack>
    </>
  )
}
